export default __webpack_public_path__ + "static/testimonial-photo-2-b07a445de645b74f6dc7ebf97b0a023e.png";